<div class="body">
  <div class="container mt-4">
    <div class="title-box">
      <h3 class="txtbienvenida">
        Consultar operaciones
        <span class="txtbienvenida-2">Aliado Financiero</span>
      </h3>
    </div>
  </div>
  <div class="container mt-4">
    <form [formGroup]="consultaSolicitudesForm" (ngSubmit)="consultarSolicitudesForm()">
      <div class="row myForm">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
          <div class="mb-3 form-label" [ngClass]="{err: isValidFieldConsultaSolicitudesForm('monto')}">
            <label class="form-label" for="monto">Monto aprobado</label>
            <input type="text" [maxlength]="LONGITUD_MAXIMA_MONTO" class="form-control" [ngClass]="{
                'is-invalid': isValidFieldConsultaSolicitudesForm('monto')}" formControlName="monto" appOnlyNumbers />
              <div class="invalid-feedback">Solo números</div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3 form-label" [ngClass]="{'is-invalid':isValidFieldConsultaSolicitudesForm('origenRecursos')}">
              <label class="form-label" for="origenRecursos">Origen de los recursos</label>
              <select #orig id="orig" class="form-control" formControlName="origenRecursos"
                title="Seleccione...">
                <option value="">Seleccione...</option>
                <option value="RECURSOS_PROPIOS">Recursos propios</option>
                <option value="RECURSOS_BANCOLDEX">Recursos bancoldex</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row myForm">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3 form-label" [ngClass]="{err: isValidFieldConsultaSolicitudesForm('fechaInicial')}">
              <label class="form-label" for="fechaInicial">Fecha inicial de creación solicitud</label>
              <input type="date" class="form-control" [ngClass]="{'is-invalid':isValidFieldConsultaSolicitudesForm('fechaInicial')}"
                formControlName="fechaInicial" (change)="validarFechas()" min="1950-01-01" max="{{fechaActual}}" />
                <div class="invalid-feedback">
                  La fecha incial no puede ser menor a la fecha final.
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
              <div class="mb-3 form-label" [ngClass]="{err: isValidFieldConsultaSolicitudesForm('fechaFinal')}">
                <label class="form-label" for="fechaFinal">Fecha final de creación solicitud</label>
                <input type="date" class="form-control" [ngClass]="{'is-invalid': isValidFieldConsultaSolicitudesForm('fechaFinal')}"
                  formControlName="fechaFinal" (change)="validarFechas()" min="obtenerValorCampo('fechaInicial')" required />
                </div>
              </div>
            </div>
            <div class="row justify-content-md-center g-3">
              <div class="col-12 col-md-2 container-btn">
          <button class="btn btn-primary" style="width: 180px;" type="submit" [ngClass]="{
            'hvr-shrink': consultaSolicitudesForm.valid && cualquierCampoIngresado()}">
                  Consultar
                </button>
              </div>
              <div class="col-12 col-md-2 container-btn">
                <button class="btn btn-primary hvr-shrink" type="button" style="width: 180px;" (click)="limpiarFormulario()">
                  Limpiar filtros
                </button>
              </div>
              <div class="col-12 col-md-2 container-btn">
                <button type="button" class="btn btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">
                  Volver
                </button>
              </div>
            </div>
            @if (consulta) {
              <div class="row justify-content-md-center mt-3 g-3">
                <div class="col-12 col-md-3 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button" (click)="generarReporte(true)">
                    Exportar a Excel
                  </button>
                </div>
                <div class="col-12 col-md-3 container-btn">
                  <button class="btn btn-primary hvr-shrink" style="width: 180px;" type="button" (click)="generarReporte(false)">
                    Exportar a txt
                  </button>
                </div>
              </div>
            }
          </form>
          @if (consulta) {
            <div class="row pr-3 pl-3">
              <div class="table-responsive">
                <table class="table table-striped table-borderless rounded">
                  <thead class="table_head">
                    <tr>
                      <th scope="col" class="no-styles table-header">
                        Número de solicitud
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Estado solicitud
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha creación solicitud
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha envío solicitud aliado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Monto solicitado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Plazo solicitado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Monto ofertado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Tasa ofertada
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Plazo ofertado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Origen recursos
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha envío propuesta
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha aceptación propuesta
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Monto desembolsado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Tasa desembolsada
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Plazo desembolsado
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Fecha desembolso
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Usuario género propuesta
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Usuario aprobó propuesta
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Identificación beneficiario
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Nombre beneificiario
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Departamento
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Ciudad
                      </th>
                      <th scope="col" class="no-styles table-header">
                        Acceso a crédito formal con anterioridad
                      </th>
                      <th scope="col" class="no-styles table-header">Ver detalles</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (sol of solicitudes; track sol) {
                      <tr>
                        <td>{{ sol.idSolicitud }}</td>
                        <td>{{ sol.estadoSolicitud }}</td>
                        <td>{{ sol.fechaCreacion | date: "dd/MM/yyyy, h:mm a" }}</td>
                        <td>{{ sol.fechaEnvioBancoldex | date: "dd/MM/yyyy, h:mm a" }}</td>
                        <td>{{ sol.montoSolicitado | currency: "USD":"symbol":"1.0-0" }}</td>
                        <td>{{ sol.plazoSolicitado }}</td>
                        <td>{{ sol.montoOfertado | currency: "USD":"symbol":"1.0-0" }}</td>
                        <td>{{ sol.tasaOfertada }}%</td>
                        <td>{{ sol.plazoOfertado }}</td>
                        <td>{{ sol.origenRecursos }}</td>
                        <td>{{ sol.fechaEnvioOferta ? (sol.fechaEnvioOferta | date: "dd/MM/yyyy, h:mm a") : 'N.A.' }}</td>
                        <td>{{ sol.fechaAceptacionPropuesta ? (sol.fechaAceptacionPropuesta | date: "dd/MM/yyyy, h:mm a") : 'N.A.' }}</td>
                        <td>{{ sol.montoFinal ? (sol.montoFinal | currency: "USD":"symbol":"1.0-0") : 'N.A.' }}</td>
                        <td>{{ sol.tasaFinal }}</td>
                        <td>{{ sol.plazoFinal ? sol.plazoFinal : 'N.A.' }}</td>
                        <td>{{ sol.fechaDesembolso ? (sol.fechaDesembolso | date: "dd/MM/yyyy, h:mm a") : 'N.A.' }}</td>
                        <td>{{ sol.usuarioGeneroOferta ? sol.usuarioGeneroOferta : 'N.A.' }}</td>
                        <td>{{ sol.usuarioAproboOferta ? sol.usuarioAproboOferta : 'N.A.' }}</td>
                        <td>{{ sol.tipoDocumento + " " + sol.numeroDocumento }}</td>
                        <td>{{ sol.nombreBeneficiario }}</td>
                        <td>{{ sol.departamento }}</td>
                        <td>{{ sol.ciudad }}</td>
                        <td>{{ sol.creditoAnterior ? sol.creditoAnterior : 'N.A.' }}</td>
                        <td>
                          <a [routerLink]="['../detallePropuestaIF/verDetallePropuesta/',sol.idSolicitud]"
                            (click)="guardarFiltro()"><i class="fas fa-eye text-light"></i></a>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            @if (consulta) {
              <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
              [totalPaginas]="totalPaginas"></app-pagination>
            }
            <!-- Modal -->
            <div class="modal fade text-center" style="color: black;" id="mensajeModal" tabindex="-1"
              aria-labelledby="mensajeModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-body justify-content-md-center">
                    <div class="row">
                      <div class="col-12 col-sm-12 me-3 ms-3">
                        <h2>No se encontraron operaciones con los criterios seleccionados</h2>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer justify-content-md-center">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a id="downloadFile" style="display: none" aria-label="Download file"></a>
          <div class="footer-body"></div>
        </div>
        <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
